export default "__VITE_ASSET__Dvi1gDam__"